import { gql } from '@apollo/client';
import { verificationTypeItem } from './fragments';

export const VERIFICATION_TYPE_QUERY = gql`
  query verificationType($verificationTypeId: Int!) {
    verificationType(verificationTypeId: $verificationTypeId) {
      ...verificationTypeItem
    }
  }
  ${verificationTypeItem}
`;

export const ALL_VERIFICATION_TYPES_QUERY = gql`
  query allVerificationTypes {
    allVerificationTypes {
      id
      name
    }
  }
`;

export const DOCUMENT_TYPES_QUERY = gql`
  query documentTypes {
    documentTypes {
      id
      code
      name
    }
  }
`;

export const ALL_KIND_OF_VERIFICATIONS_QUERY = gql`
  query allKindOfVerifications {
    allKindOfVerifications {
      id
      code
      name
    }
  }
`;

export const ALL_REPORTS_QUERY = gql`
  query allReports {
    allReports {
      id
      name
    }
  }
`;

export const VERIFICATION_VALIDITY_TYPES_QUERY = gql`
  query validityTypes {
    validityTypes {
      id
      code
      name
    }
  }
`;
